import React, { useEffect, useState } from "react";

const VERSION_URL = "/version.json";
const POLL_INTERVAL = 5 * 60 * 1000; // 5 minutes

const VersionChecker: React.FC = () => {
  const [currentVersion, setCurrentVersion] = useState<string | null>(null);
  const [updateAvailable, setUpdateAvailable] = useState(false);

  // Fetch version from version.json
  const fetchVersion = async () => {
    try {
      const response = await fetch(VERSION_URL, { cache: "no-store" });
      if (!response.ok) {
        console.error("Failed to fetch version.json");
        return;
      }
      const data = await response.json();
      if (currentVersion && data.version !== currentVersion) {
        setUpdateAvailable(true);
      }
      if (!currentVersion) {
        setCurrentVersion(data.version);
      }
    } catch (error) {
      console.error("Error fetching version.json:", error);
    }
  };

  useEffect(() => {
    fetchVersion();
    const interval = setInterval(fetchVersion, POLL_INTERVAL);
    return () => clearInterval(interval);
  }, [currentVersion]);

  const handleReload = () => {
    window.location.reload();
  };

  if (!updateAvailable) {
    return null;
  }

  return (
    <div
      style={{
        position: "fixed",
        bottom: 20,
        right: 20,
        backgroundColor: "#323232",
        color: "white",
        padding: "10px 20px",
        borderRadius: 5,
        boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
        zIndex: 1000,
        cursor: "pointer",
      }}
      onClick={handleReload}
      role="button"
      aria-label="Reload to update"
    >
      A new version is available. Click here to update.
    </div>
  );
};

export default VersionChecker;
